import { captureException } from 'marketing-site/lib/sentry'
import { IMarketoFormValues } from 'marketing-site/src/library/components/MarketoFormV2'
import { IWebinar } from '../index'
import createRegisterParams from './helpers/createRegisterParams'
import createTags from './helpers/createTags'
import registerToWebinar from './helpers/registerToWebinar'

function validateFormValues(values: IMarketoFormValues) {
  const errorMessage = 'Webinar form submission missing mandatory value'
  let missingFields = ''
  if (!values.FirstName) missingFields += ' FirstName'
  if (!values.LastName) missingFields += ' LastName'
  if (!values.Email) missingFields += ' Email'
  if (missingFields.length > 0) {
    const validationError = new Error(`${errorMessage}${missingFields}`)
    captureException(validationError)
  }
}
export interface IHandleFormSubmitArgs {
  values: IMarketoFormValues
  webinarProps: IWebinar
  utmSource: string
  onSuccessfulRegistration: () => void
  onFirstNameChange: (firstName: string) => void
  onVideoStart: () => void
  onJoinUrlChange: (joinUrl: string) => void
  onErrorsRaised: (errors: string[] | null) => void
}

export default async function handleFormSubmit({
  values,
  webinarProps,
  utmSource,
  onSuccessfulRegistration,
  onFirstNameChange,
  onVideoStart,
  onJoinUrlChange,
  onErrorsRaised,
}: IHandleFormSubmitArgs) {
  onErrorsRaised(null)
  validateFormValues(values)

  try {
    await createTags(webinarProps, values)
  } catch (error) {
    captureException(error)
  }

  if (webinarProps.isScheduled) {
    const registerResponse = await registerToWebinar(
      createRegisterParams(webinarProps, values, utmSource),
    )

    if (registerResponse.errors) {
      onErrorsRaised(registerResponse.errors)
      return
    }

    onFirstNameChange(values.FirstName)
    onJoinUrlChange(registerResponse.data.joinUrl)
    onSuccessfulRegistration()
  } else {
    onVideoStart()
  }
}
